import { render, staticRenderFns } from "./TagReference.vue?vue&type=template&id=be43fefc&"
import script from "./TagReference.vue?vue&type=script&lang=js&"
export * from "./TagReference.vue?vue&type=script&lang=js&"
import style0 from "./TagReference.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports